$(document).ready(function () {

    // ── State ─────────────────────────────────────────────────────────
    var _prevBoxVariantId = '';
    var _summaryReached   = false;
    var _boxQty           = 0;
    var _minQty           = parseInt($('#step1').attr('data-minqty')) || 5;
    var items             = [];
    var _currentStep      = 1;
    var _postnummerOk     = false; // firmagave: tüm kutular gaveeske → Oslo postnummer şart
    var _pnPulseShown     = false; // "Sjekk postnummer" pulse vurgusu bu episode'da oynatıldı mı

    // Firmagave bud-leveringsområde (Bring postnummerregister, 10 kommuner):
    // Oslo, Bærum, Asker (kun Asker-proper, ikke Røyken/Hurum), Lørenskog,
    // Rælingen, Lillestrøm, Nittedal, Nordre Follo, Nesodden, Enebakk.
    // 826 postnummer komprimert til sammenhengende intervaller [lav,høy].
    var FG_PN_RANGES = [[1,1],[10,10],[15,15],[18,18],[21,21],[24,24],[26,26],[28,28],[30,30],[32,34],[37,37],[40,40],[45,48],[50,50],[55,55],[101,107],[109,125],[129,136],[138,140],[150,155],[157,162],[164,188],[190,196],[198,198],[201,204],[207,208],[211,218],[230,230],[240,240],[244,244],[247,247],[250,260],[262,268],[270,284],[286,287],[301,309],[311,311],[313,319],[323,323],[330,330],[340,340],[349,383],[401,406],[409,413],[415,415],[421,424],[440,442],[445,445],[450,452],[454,465],[467,470],[472,496],[501,513],[515,518],[520,520],[540,540],[550,598],[601,609],[611,624],[626,626],[650,694],[701,702],[705,705],[710,710],[712,712],[750,758],[760,760],[763,768],[770,779],[781,791],[801,801],[805,807],[840,840],[850,858],[860,864],[870,877],[880,884],[890,891],[901,905],[907,908],[913,915],[950,960],[962,964],[968,973],[975,988],[1001,1001],[1003,1003],[1005,1009],[1011,1011],[1051,1056],[1061,1065],[1067,1069],[1071,1071],[1081,1081],[1083,1084],[1086,1089],[1101,1102],[1108,1109],[1112,1112],[1150,1158],[1160,1170],[1172,1172],[1176,1179],[1181,1182],[1184,1185],[1187,1189],[1201,1201],[1203,1205],[1207,1207],[1214,1215],[1250,1259],[1262,1263],[1266,1266],[1270,1275],[1278,1279],[1281,1281],[1283,1286],[1290,1291],[1294,1295],[1300,1309],[1311,1314],[1316,1319],[1321,1342],[1344,1344],[1346,1346],[1348,1354],[1356,1369],[1371,1373],[1375,1381],[1383,1397],[1399,1406],[1408,1425],[1450,1454],[1456,1459],[1461,1488],[1900,1901],[1903,1903],[1910,1912],[1914,1914],[1916,1917],[1920,1921],[1923,1926],[2000,2001],[2003,2021],[2023,2023],[2025,2029]];
    function isOsloPostnummer(pn) {
        var n = parseInt(pn, 10);
        if (isNaN(n)) return false;
        for (var i = 0; i < FG_PN_RANGES.length; i++) {
            if (n >= FG_PN_RANGES[i][0] && n <= FG_PN_RANGES[i][1]) return true;
        }
        return false;
    }

    // ── Step 3 state ──────────────────────────────────────────────────
    var _step3Mode          = 'preset-logo'; // 'preset-logo' | 'corporate' | 'ready'
    var _logoEnabled        = false;
    var _logoFileName       = '';
    var _logoNote           = '';
    var _corpFileName       = '';
    var _corpNote           = '';
    var _presetLogoFileName = '';
    var _presetLogoNote     = '';
    var fgFileUrls          = {}; // opplastede filer: slot -> { url, name }

    // ── Step 3 preview cache ──────────────────────────────────────────
    var _previewCache = {};

    function showStep3Preview(handle, fallbackSrc) {
        var imgs = _previewCache[handle];
        var src = fallbackSrc;
        var isVideo = false;
        if (imgs && imgs.length) {
            var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            var idx = spaces >= 18 ? 2 : spaces >= 12 ? 1 : 0;
            var item = imgs[idx] || imgs[idx - 1] || imgs[0] || null;
            if (item) {
                if (typeof item === 'object' && item.url) {
                    src = item.url;
                    isVideo = (item.type === 'video');
                } else {
                    src = item;
                }
            }
        }
        if (isVideo) {
            showStep3Video(src);
        } else if (src) {
            $('#step3-preview-video').hide();
            $('#step3-preview-img').attr('src', src).show();
            $('.step3-preview-placeholder').hide();
        }
    }

    function showStep3Video(url) {
        var $v = $('#step3-preview-video');
        if ($v.attr('src') !== url) { $v.attr('src', url); $v[0] && $v[0].load(); }
        $v.show();
        $('#step3-preview-img').hide();
        $('.step3-preview-placeholder').hide();
    }

    function clearStep3Preview() {
        $('#step3-preview-img').attr('src', '').hide();
        var $v = $('#step3-preview-video');
        var v = $v[0];
        if (v) { v.pause(); }
        $v.attr('src', '').hide();
        $('.step3-preview-placeholder').show();
    }

    // ── Step 4 state ──────────────────────────────────────────────────
    var _step4Mode               = 'preset-logo';
    var _card4LogoEnabled        = false;
    var _card4LogoFileName       = '';
    var _card4LogoNote           = '';
    var _card4CorpFileName       = '';
    var _card4CorpNote           = '';
    var _card4PresetLogoFileName = '';
    var _card4PresetLogoNote     = '';

    // ── Tab state ─────────────────────────────────────────────────────
    function setActiveTab(active) {
        $('.cmb-tab').each(function () {
            var s = parseInt($(this).data('step'));
            $(this).removeClass('cmb-tab--active cmb-tab--done');
            if (active > 6) {
                $(this).addClass('cmb-tab--done');
            } else if (s === active) {
                $(this).addClass('cmb-tab--active');
            } else if (s < active) {
                $(this).addClass('cmb-tab--done');
            } else {
                if (s === 6) {
                    if (_summaryReached) $(this).addClass('cmb-tab--done');
                } else {
                    var $sum = $('#step' + s + '-summary');
                    if ($sum.length && $.trim($sum.html()) !== '') $(this).addClass('cmb-tab--done');
                }
            }
        });
    }

    // ── Footer back button ────────────────────────────────────────────
    var _backTargets = { 2: 1, 3: 2, 4: 3, 5: 4, 6: 5 };
    var _skipHistoryPush = false;
    function updateFooterBackBtn(n) {
        var $btn = $('#cmb-footer-back-btn');
        if (window.innerWidth >= 641 && n > 1 && _backTargets[n] !== undefined) {
            $btn.data('target', _backTargets[n]).show();
        } else {
            $btn.hide();
        }
    }
    $(document).on('click', '#cmb-footer-back-btn', function() {
        window.editStep(parseInt($(this).data('target')));
    });

    // ── Show only one step ────────────────────────────────────────────
    function showOnlyStep(n) {
        _currentStep = n;
        if (!_skipHistoryPush) history.pushState({ wizard: true }, '');
        $('#step1, #step2, #step3, #step4, #gift-message-div').hide();
        $('#gift-price-summary, #add-to-card-div').hide();
        if (n === 6) {
            _summaryReached = true;
            $('#gift-price-summary').show();
            $('#add-to-card-div').show();
            hideOmslagPreviewBtn();
            updateFooterBackBtn(6);
            $('#cmb-footer-next-btn').hide();
            $('#cmb-footer-bar').show();
            renderMacronSummary();
        } else {
            if (n === 1) $('#step1').show();
            else if (n === 2) { $('#step2').show(); ftrMacronsShow(); updateFtrMacronStrip(); }
            else if (n === 3) $('#step3').show();
            else if (n === 4) $('#step4').show();
            else if (n === 5) $('#gift-message-div').show();
            if (n !== 2) ftrMacronsHide();
            if (n !== 3) hideOmslagPreviewBtn();
            $('#cmb-footer-next-btn').show();
            updateFooterBackBtn(n);
            updateFooterBtn(n);
            $('#cmb-footer-bar').show();
        }
        var tabTop = $('#cmb-tabs').offset().top;
        $('html, body').stop().animate({ scrollTop: Math.max(0, tabTop - 90) }, 300);
    }

    // ── Footer button label / state ───────────────────────────────────
    function updateFooterBtn(step) {
        var $btn = $('#cmb-footer-next-btn');

        if (step === 1) {
            var hasSel = $('.step1-child.selected').length > 0;
            var qtyOk  = hasSel && _boxQty >= _minQty;
            var needsPost = hasSel && !_postnummerOk; // önce Oslo postnummer kontrolü
            $btn.text(needsPost ? 'Sjekk postnummer →' : 'Neste →').prop('disabled', !qtyOk);
            // Buton aktif + "Sjekk postnummer" durumuna ilk geçtiğinde tek seferlik pulse
            if (qtyOk && needsPost) {
                if (!_pnPulseShown) {
                    _pnPulseShown = true;
                    $btn.removeClass('cmb-btn-pulse');
                    void $btn[0].offsetWidth; // reflow → animasyonu garanti başlat
                    $btn.addClass('cmb-btn-pulse');
                }
            } else {
                _pnPulseShown = false;
                $btn.removeClass('cmb-btn-pulse');
            }
        } else if (step === 2) {
            var tQty = parseInt($('.step2-c').attr('data-totalqty')) || 0;
            var max  = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            $btn.prop('disabled', tQty < max).text('Neste →');
        } else if (step === 3) {
            if (_step3Mode === 'corporate') {
                $btn.prop('disabled', false).text(_corpFileName ? ('Neste →') : 'Fortsett uten omslag');
            } else if (_step3Mode === 'preset-logo') {
                var hasCover = $('.cover-box.selected-cover-box').length > 0;
                var hasLogo  = _presetLogoFileName !== '';
                if (!hasCover) {
                    $btn.prop('disabled', false).text('Fortsett uten omslag');
                } else if (!hasLogo) {
                    $btn.prop('disabled', true).text(window.innerWidth <= 640 ? 'Last opp logo' : 'Last opp logo for å fortsette');
                } else {
                    $btn.prop('disabled', false).text('Neste →');
                }
            } else {
                var hasCover = $('.cover-box.selected-cover-box').length > 0;
                if (_logoEnabled && _logoFileName === '') {
                    $btn.prop('disabled', true).text(window.innerWidth <= 640 ? 'Last opp logo' : 'Last opp logo for å fortsette');
                } else {
                    $btn.prop('disabled', false).text(hasCover ? ('Neste →') : 'Fortsett uten omslag');
                }
            }
        } else if (step === 4) {
            if (_step4Mode === 'corporate') {
                $btn.prop('disabled', false).text('Neste →');
            } else if (_step4Mode === 'preset-logo') {
                var hasCard = $('.greeting-card.selected-card-box').length > 0;
                var hasLogo = _card4PresetLogoFileName !== '';
                if (!hasCard) {
                    $btn.prop('disabled', false).text('Fortsett uten kort');
                } else if (!hasLogo) {
                    $btn.prop('disabled', true).text(window.innerWidth <= 640 ? 'Last opp logo' : 'Last opp logo for å fortsette');
                } else {
                    $btn.prop('disabled', false).text('Neste →');
                }
            } else {
                var hasCard = $('.greeting-card.selected-card-box').length > 0;
                if (_card4LogoEnabled && _card4LogoFileName === '') {
                    $btn.prop('disabled', true).text(window.innerWidth <= 640 ? 'Last opp logo' : 'Last opp logo for å fortsette');
                } else {
                    $btn.prop('disabled', false).text(hasCard ? ('Neste →') : 'Fortsett uten kort');
                }
            }
        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            $btn.prop('disabled', false).text(hasMsg ? ('Bekreft og fullfør') : 'Fortsett uten melding');
        }
    }

    // ── Summary builders ──────────────────────────────────────────────
    function showStep1Summary() {
        var img   = $('.step1-child.selected').attr('data-image') || '';
        var title = $('#step1').attr('data-bundleproducttitle') || '';
        var price = $('#step1').attr('data-bundleproductprice') || '';
        $('#step1-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">1</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p><p class="cmb-sum-price">' + price + ',-</p></div>'
            + '</div>'
        );
    }
    function showStep2Summary() {
        var imgs  = [];
        $('.macron-temp-div img').each(function () { if (imgs.length < 10) imgs.push($(this).attr('src')); });
        var count = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $('#step2-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">2</span>'
            + '<div class="cmb-sum-macrons">' + imgs.map(function (s) { return '<img class="cmb-sum-macron" src="' + s + '" alt="">'; }).join('') + '</div>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + count + ' makroner valgt</p></div>'
            + '</div>'
        );
    }
    function showStep3Summary(title, img) {
        $('#step3-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">3</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep4Summary(title, img) {
        $('#step4-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">4</span>'
            + (img ? '<div class="cmb-sum-media"><img class="cmb-sum-img" src="' + img + '" alt=""></div>' : '')
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function showStep5Summary(title) {
        $('#step5-summary').html(
            '<div class="cmb-sum-inner"><span class="cmb-sum-num">5</span>'
            + '<div class="cmb-sum-text"><p class="cmb-sum-title">' + title + '</p></div>'
            + '</div>'
        );
    }
    function resetSummariesFrom(step) {
        for (var i = step; i <= 5; i++) $('#step' + i + '-summary').html('');
        if (step <= 2) _summaryReached = false;
    }

    // ── Full reset helper ─────────────────────────────────────────────
    function fullReset() {
        $('.full-basket').hide();
        $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('#gift-message').val('');
        resetSummariesFrom(1);
        $(".cover_box_input, .greeting_card_input").prop('checked', false);
        $(".macron-qty").each(function () { $(this).text(0); });
        $(".step2-child-selected").each(function () { $(this).addClass('choose-image').html(''); });
        $('.step2-c').attr('data-totalqty', '0');
        $('.preset-card').removeClass('active');
        $(".step1-child").removeClass("selected");
        _prevBoxVariantId = '';
        _boxQty = 0;
        resetStep3State();
        resetStep4State();
        resetQtyDrawers();
        setActiveTab(1);
        showOnlyStep(1);
        price_calculate();
    }

    function resetStep3State() {
        _step3Mode          = 'preset-logo';
        _logoEnabled        = false;
        _logoFileName       = '';
        _logoNote           = '';
        _corpFileName       = '';
        _corpNote           = '';
        _presetLogoFileName = '';
        _presetLogoNote     = '';
        delete fgFileUrls.logo; delete fgFileUrls.corp; delete fgFileUrls.presetLogo;
        $('.step3-type-tab').removeClass('active');
        $('.step3-type-tab[data-panel="preset-logo"]').addClass('active');
        $('#step3-panel-preset-logo').show();
        $('#step3-panel-corporate').hide();
        $('#step3-panel-ready').hide();
        $('#logo-addon-check').prop('checked', false);
        $('#logo-addon-fields').hide();
        $('#logo-upload-zone').removeClass('has-file');
        $('#logo-filename').hide().text('');
        $('#logo-upload-zone .corp-upload-title, #logo-upload-zone .corp-upload-subtitle').show();
        $('#logo-note').val('');
        $('#corp-upload-zone').removeClass('has-file');
        $('#corp-filename').hide().text('');
        $('#corp-upload-zone .corp-upload-title, #corp-upload-zone .corp-upload-subtitle').show();
        $('#corp-note').val('');
        $('#preset-logo-upload-zone').removeClass('has-file');
        $('#preset-logo-filename').hide().text('');
        $('#preset-logo-upload-zone .corp-upload-title, #preset-logo-upload-zone .corp-upload-subtitle').show();
        $('#preset-logo-note').val('');
        $('#preset-logo-addon-section').show().addClass('logo-upload-disabled');
        $('#ready-logo-addon-section').hide().addClass('logo-upload-disabled');
        clearStep3Preview();
        hideOmslagPreviewBtn();
    }

    function resetStep4State() {
        _step4Mode               = 'preset-logo';
        _card4LogoEnabled        = false;
        _card4LogoFileName       = '';
        _card4LogoNote           = '';
        _card4CorpFileName       = '';
        _card4CorpNote           = '';
        _card4PresetLogoFileName = '';
        _card4PresetLogoNote     = '';
        delete fgFileUrls.card4Logo; delete fgFileUrls.card4Corp; delete fgFileUrls.card4PresetLogo;
        $('.step4-type-tab').removeClass('active');
        $('.step4-type-tab[data-panel="preset-logo"]').addClass('active');
        $('#step4-panel-preset-logo').show();
        $('#step4-panel-corporate').hide();
        $('#step4-panel-ready').hide();
        $('#card-logo-addon-check').prop('checked', false);
        $('#card-logo-addon-fields').hide();
        $('#card-logo-upload-zone').removeClass('has-file');
        $('#card-logo-filename').hide().text('');
        $('#card-logo-upload-zone .corp-upload-title, #card-logo-upload-zone .corp-upload-subtitle').show();
        $('#card-logo-note').val('');
        $('#card-corp-upload-zone').removeClass('has-file');
        $('#card-corp-filename').hide().text('');
        $('#card-corp-upload-zone .corp-upload-title, #card-corp-upload-zone .corp-upload-subtitle').show();
        $('#card-corp-note').val('');
        $('#preset-card-logo-upload-zone').removeClass('has-file');
        $('#preset-card-logo-filename').hide().text('');
        $('#preset-card-logo-upload-zone .corp-upload-title, #preset-card-logo-upload-zone .corp-upload-subtitle').show();
        $('#preset-card-logo-note').val('');
        $('#step4-panel-preset-logo .logo-addon-section').addClass('logo-upload-disabled');
        $('#step4-panel-ready .logo-addon-section').addClass('logo-upload-disabled');
    }

    // ── Tab click ─────────────────────────────────────────────────────
    $(document).on('click', '.cmb-tab', function () {
        if (!$(this).hasClass('cmb-tab--done')) return;
        window.editStep(parseInt($(this).data('step')));
    });

    // ── Back button ───────────────────────────────────────────────────
    $(document).on('click', '.cmb-back-btn', function () {
        window.editStep(parseInt($(this).data('target')));
    });

    // ── Edit step ─────────────────────────────────────────────────────
    window.editStep = function (n) {
        if (n === 1) {
            _prevBoxVariantId = $('#step1').attr('data-bundleproductvariantid') || '';
            setActiveTab(1);
            showOnlyStep(1);
        } else if (n === 2) {
            $('.full-basket').hide();
            $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
            setActiveTab(2);
            showOnlyStep(2);
        } else if (n === 3) {
            setActiveTab(3);
            showOnlyStep(3);
            updateFooterBtn(3);
            if ($('.cover-box.selected-cover-box').length > 0) showOmslagPreviewBtn();
        } else if (n === 4) {
            $('.card-filter-btn').removeClass('active');
            $('.card-filter-btn[data-filter="all"]').addClass('active');
            $('#step4-panel-ready .greeting-card').show();
            setActiveTab(4); showOnlyStep(4);
        } else if (n === 5) {
            setActiveTab(5); showOnlyStep(5);
        } else if (n === 6) {
            setActiveTab(6); showOnlyStep(6);
        }
        price_calculate();
    };

    window.addEventListener('popstate', function(e) {
        if (_currentStep > 1) {
            _skipHistoryPush = true;
            window.editStep(_currentStep - 1);
            _skipHistoryPush = false;
        }
    });

    // ── Modal (Omslag info) ───────────────────────────────────────────
    $('#info-btn-omslag').on('click', function () { $('#omslag-info-modal').fadeIn(); });
    $('#close-info-modal').on('click', function () { $('#omslag-info-modal').fadeOut(); });
    $(document).mouseup(function (e) {
        var $mc = $(".modal-content");
        if (!$mc.is(e.target) && $mc.has(e.target).length === 0) $('#omslag-info-modal').fadeOut();
    });

    // ── Step 1: qty drawer helpers ────────────────────────────────────
    function resetQtyDrawers() {
        $('.step1-qty-inline').each(function () {
            $(this).removeClass('qty-visible');
            $(this).find('.step1-qty-val').hide().text('');
            $(this).find('.step1-qty-dec').hide();
            $(this).find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
        });
    }

    // ── Step 1: box selection ─────────────────────────────────────────
    $(document).on('click', '.step1-child', function () {
        var $this           = $(this);
        var alreadySelected = $this.hasClass('selected');

        if (alreadySelected) {
            $this.removeClass('selected');
            _boxQty = 0;
            $('#step1')
                .attr('data-bundleProductPrice', '0')
                .attr('data-bundleProductVariantId', '')
                .attr('data-bundleProductTitle', '')
                .attr('data-productbundlespace', '0');
            resetQtyDrawers();
            resetStep2Basket();
            resetStep3State();
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".cover-box").removeClass("selected-cover-box");
            $(".greeting-card").removeClass("selected-card-box");
            $('#gift-message').val('');
            resetSummariesFrom(2);
            _postnummerOk = false;
            $('#postnummer-gate').removeClass('open');
            setActiveTab(1);
            ftrQtyHide();
            updateFooterBtn(1);
            price_calculate();
            return;
        }

        $(".step1-child").removeClass("selected");
        $this.addClass("selected");
        var newId = $this.attr("data-variantid") || '';
        $('#step1')
            .attr('data-bundleProductPrice',     $this.attr("data-price"))
            .attr('data-bundleProductVariantId', newId)
            .attr('data-bundleProductTitle',     $this.attr("data-title"))
            .attr('data-productbundlespace',     $this.attr('data-bundlespace'));

        // Reset other drawers
        var $qtyWrap = $this.find('.step1-qty-inline');
        $('.step1-qty-inline').not($qtyWrap).each(function () {
            $(this).removeClass('qty-visible');
            $(this).find('.step1-qty-val').hide().text('');
            $(this).find('.step1-qty-dec').hide();
            $(this).find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
        });

        if (!alreadySelected) {
            _boxQty = 0;
            $qtyWrap.find('.step1-qty-val').hide().text('');
            $qtyWrap.find('.step1-qty-dec').hide();
            $qtyWrap.find('.step1-qty-inc').text('Velg').addClass('step1-qty-velg');
        }
        $qtyWrap.addClass('qty-visible');

        // Mobile: show footer qty first, then flash the visible button
        if (window.innerWidth <= 640) {
            ftrQtyShow();
            syncFtrFromDrawer();
            flashVelgBtn($('#cmb-ftr-inc'));
        } else {
            flashVelgBtn($qtyWrap.find('.step1-qty-inc'));
        }

        var step2Done = $.trim($('#step2-summary').html()) !== '';
        var isChange  = _prevBoxVariantId && newId !== _prevBoxVariantId;

        if (isChange && step2Done) {
            // User changed box after progressing — full reset from step 2
            resetStep2Basket();
            var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
            $('.step2-selected-c').html('');
            for (var i = 0; i < spaces; i++) {
                $('.step2-selected-c').append('<div class="step2-child-selected choose-image" style="cursor:unset"></div>');
            }
            $(".cover_box_input, .greeting_card_input").prop('checked', false);
            $(".cover-box").removeClass("selected-cover-box");
            $(".greeting-card").removeClass("selected-card-box");
            $('#gift-message').val('');
            resetStep3State();
            resetStep4State();
            resetSummariesFrom(2);
            setActiveTab(1);
            updateFooterBtn(1);
        } else {
            updateFooterBtn(1);
        }
        price_calculate();
    });

    // ── Step 1: qty inc/dec ───────────────────────────────────────────
    $(document).on('click', '.step1-qty-inc', function (e) {
        e.stopPropagation();
        var $btn = $(this);
        if (_boxQty < _minQty) {
            _boxQty = _minQty;
            $btn.text('+').removeClass('step1-qty-velg');
        } else {
            _boxQty++;
        }
        var $wrap = $btn.closest('.step1-qty-inline');
        $wrap.find('.step1-qty-val').show().text(_boxQty);
        $wrap.find('.step1-qty-dec').show().prop('disabled', _boxQty <= _minQty);
        syncFtrFromDrawer();
        updateFooterBtn(1);
        price_calculate();
    });

    $(document).on('click', '.step1-qty-dec', function (e) {
        e.stopPropagation();
        if (_boxQty <= _minQty) return;
        _boxQty--;
        var $wrap = $(this).closest('.step1-qty-inline');
        $wrap.find('.step1-qty-val').text(_boxQty);
        $wrap.find('.step1-qty-dec').prop('disabled', _boxQty <= _minQty);
        syncFtrFromDrawer();
        updateFooterBtn(1);
        price_calculate();
    });

    // ── Gaveeske: Oslo posta kodu kontrolü (firmagave: hverdag/fallback yok) ──
    function openPostnummerGate() {
        _postnummerOk = false;
        $('#postnummer-input').val('');
        $('#postnummer-msg').text('').attr('class', 'postnummer-msg');
        $('#postnummer-leveringsdato').hide();
        $('#postnummer-continue').prop('disabled', true);
        $('#postnummer-gate').addClass('open');
        setTimeout(function () { $('#postnummer-input').focus(); }, 120);
    }
    // Kapat (X / dış tıklama): kutu seçimi korunur; footer "Sjekk postnummer" kalır
    function closePostnummerGate() {
        $('#postnummer-gate').removeClass('open');
        updateFooterBtn(1);
    }
    $(document).on('input', '#postnummer-input', function () {
        var v = $(this).val().replace(/\D/g, '').slice(0, 4);
        if (v !== $(this).val()) $(this).val(v);
        var $msg = $('#postnummer-msg');
        var $lev = $('#postnummer-leveringsdato');
        if (v.length < 4) {
            _postnummerOk = false;
            $msg.text('').attr('class', 'postnummer-msg');
            $lev.hide();
        } else if (isOsloPostnummer(v)) {
            _postnummerOk = true;
            $msg.text('✓ Ja, vi leverer firmagaver til dere!').attr('class', 'postnummer-msg postnummer-msg--ok');
            $lev.html(
                'Tidligste levering: <strong>' + fgFmtDate(fgEarliestDelivery(7)) + '</strong> (kl. 10:30–16:00).<br>' +
                'Med logo eller eget design: fra <strong>' + fgFmtDate(fgEarliestDelivery(21)) + '</strong>.'
            ).show();
        } else {
            _postnummerOk = false;
            $msg.text('Firmagaver leveres kun med bud i Oslo-området.').attr('class', 'postnummer-msg postnummer-msg--no');
            $lev.hide();
        }
        $('#postnummer-continue').prop('disabled', !_postnummerOk);
        updateFooterBtn(1);
    });
    $(document).on('keydown', '#postnummer-input', function (e) {
        if (e.key === 'Enter' && _postnummerOk) $('#postnummer-continue').click();
    });
    // Oslo kodu geçerli → modal kapanır, makaron adımına geçer
    $(document).on('click', '#postnummer-continue', function () {
        if (!_postnummerOk) return;
        $('#postnummer-gate').removeClass('open');
        $('#cmb-footer-next-btn').trigger('click');
    });
    $(document).on('click', '#postnummer-close', function () { closePostnummerGate(); });
    $(document).on('click', '#postnummer-gate', function (e) {
        if (e.target === this) closePostnummerGate();
    });

    // ── Mobile: footer macaron strip (step 2) ────────────────────────
    function updateFades() {
        var el = document.getElementById('cmb-ftr-macron-strip');
        if (!el) return;
        var $wrap = $('#cmb-ftr-strip-wrap');
        $wrap.toggleClass('fade-left',  el.scrollLeft > 4);
        $wrap.toggleClass('fade-right', el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
    }

    function updateFtrMacronStrip() {
        if (window.innerWidth > 640) return;
        var $strip = $('#cmb-ftr-macron-strip');
        var $count = $('#cmb-ftr-macron-count');
        var max    = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        var total  = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        $strip.empty();
        $('.macron-temp-div').each(function () {
            var src = $(this).find('img.card-img-e').attr('src') || '';
            if (src) $strip.append('<img class="ftr-macron-avatar" src="' + src + '" alt="">');
        });
        $count.text(total + ' / ' + max);
        setTimeout(updateFades, 30);
        if ($('#cmb-kurv-sheet').hasClass('open')) renderKurvSheet();
    }

    function ftrMacronsShow() {
        if (window.innerWidth <= 640) $('#cmb-footer-macrons').css('display', 'flex');
    }
    function ftrMacronsHide() { $('#cmb-footer-macrons').hide(); }

    // ── Bottom sheet: Din kurv ────────────────────────────────────────
    function renderKurvSheet() {
        var $content = $('#cmb-kurv-sheet-content');
        $content.empty();
        var total = parseInt($('.step2-c').attr('data-totalqty')) || 0;
        if (total === 0) {
            $content.html('<p class="kurv-sheet-empty">Ingen makroner valgt ennå.</p>');
            return;
        }
        var html = '<div class="kurv-sheet-grid">';
        $('.macron-temp-div').each(function () {
            var src     = $(this).find('img.card-img-e').attr('src') || '';
            var name    = $(this).data('macronname') || '';
            var crossId = $(this).find('.cross-icon').attr('data-crossid') || '';
            html += '<div class="kurv-sheet-item">'
                + '<div class="kurv-sheet-img-wrap">'
                + '<img src="' + src + '" alt="' + name + '">'
                + '<button type="button" class="kurv-sheet-remove" data-crossid="' + crossId + '">×</button>'
                + '</div>'
                + '<p class="kurv-sheet-name">' + name + '</p>'
                + '</div>';
        });
        html += '</div>';
        $content.html(html);
    }

    function openKurvSheet()  { renderKurvSheet(); $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').addClass('open'); }
    function closeKurvSheet() {
        $('#cmb-kurv-sheet-overlay, #cmb-kurv-sheet').removeClass('open');
        setTimeout(function () { $('#cmb-kurv-sheet-content').empty(); }, 320);
    }

    $('#cmb-se-kurv-btn').on('click', openKurvSheet);
    $(document).on('click', '#cmb-ftr-strip-wrap', openKurvSheet);

    function flashKurvBtn() {
        var $btn = $('#cmb-se-kurv-btn');
        $btn.removeClass('kurv-btn--flash');
        void $btn[0].offsetWidth;
        $btn.addClass('kurv-btn--flash');
        setTimeout(function() { $btn.removeClass('kurv-btn--flash'); }, 3300);
    }
    function flashVelgBtn($btn) {
        if (!$btn.length) return;
        $btn.removeClass('velg-btn--flash');
        void $btn[0].offsetWidth;
        $btn.addClass('velg-btn--flash');
        setTimeout(function() { $btn.removeClass('velg-btn--flash'); }, 3300);
    }
    $('#cmb-kurv-sheet-close, #cmb-kurv-sheet-overlay').on('click', closeKurvSheet);

    // ── Step 3 mobile: omslag preview sheet ───────────────────────────
    function showOmslagPreviewBtn() {
        if (window.innerWidth <= 767) {
            $('#cmb-footer-omslag-preview').css('display', 'flex');
            var $btn = $('#cmb-se-omslag-btn');
            $btn.removeClass('omslag-btn--flash');
            void $btn[0].offsetWidth;
            $btn.addClass('omslag-btn--flash');
            setTimeout(function() { $btn.removeClass('omslag-btn--flash'); }, 3300);
        }
    }
    function hideOmslagPreviewBtn() {
        $('#cmb-footer-omslag-preview').hide();
    }
    function getSelectedCoverVideoUrl() {
        var $sel = $('.cover-box.selected-cover-box');
        if (!$sel.length) return '';
        var handle = $sel.data('handle') || '';
        var cache = _previewCache[handle];
        if (!cache || !cache.length) return '';
        var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        var idx = spaces >= 18 ? 2 : spaces >= 12 ? 1 : 0;
        var item = cache[idx] || cache[idx - 1] || cache[0] || null;
        return (item && typeof item === 'object' && item.type === 'video') ? item.url : '';
    }
    function openOmslagSheet() {
        var name = $('.selected-cover-box .step3-title').text() || '';
        var videoUrl = getSelectedCoverVideoUrl();
        if (videoUrl) {
            var $sv = $('#cmb-omslag-sheet-video');
            var sv = $sv[0];
            if ($sv.attr('src') !== videoUrl) { $sv.attr('src', videoUrl); sv && sv.load(); }
            $sv.show();
            $('#cmb-omslag-sheet-img').hide();
            if (sv) sv.play();
        } else {
            var src = $('#step3-preview-img').attr('src') || '';
            $('#cmb-omslag-sheet-img').attr('src', src).show();
            $('#cmb-omslag-sheet-video').hide();
        }
        $('#cmb-omslag-sheet-name').text(name);
        $('#cmb-omslag-sheet-overlay, #cmb-omslag-sheet').addClass('open');
    }
    function closeOmslagSheet() {
        $('#cmb-omslag-sheet-overlay, #cmb-omslag-sheet').removeClass('open');
        var v = $('#cmb-omslag-sheet-video')[0];
        if (v) v.pause();
    }
    $('#cmb-se-omslag-btn').on('click', openOmslagSheet);
    $('#cmb-omslag-sheet-close, #cmb-omslag-sheet-overlay').on('click', closeOmslagSheet);

    $(document).on('click', '.kurv-sheet-remove', function () {
        var crossId = $(this).data('crossid');
        $('.step2-child-selected .cross-icon[data-crossid="' + crossId + '"]').last().trigger('click');
    });

    // ── Mobile: footer qty counter ────────────────────────────────────
    var $ftrQty = $('#cmb-footer-qty');
    var $ftrVal = $('#cmb-ftr-val');
    var $ftrInc = $('#cmb-ftr-inc');
    var $ftrDec = $('#cmb-ftr-dec');

    function ftrQtyShow() { $ftrQty.css('display', 'flex'); }
    function ftrQtyHide() { $ftrQty.hide(); }

    function syncFtrFromDrawer() {
        if (window.innerWidth > 640) return;
        if (_boxQty === 0) {
            $ftrVal.hide().text('');
            $ftrInc.text('Velg').addClass('ftr-velg');
            $ftrDec.hide().prop('disabled', true);
        } else {
            $ftrVal.show().text(_boxQty);
            $ftrInc.text('+').removeClass('ftr-velg');
            $ftrDec.show().prop('disabled', _boxQty <= _minQty);
        }
    }

    $ftrInc.on('click', function (e) {
        e.stopPropagation();
        $('.step1-child.selected .step1-qty-inc').trigger('click');
    });

    $ftrDec.on('click', function (e) {
        e.stopPropagation();
        $('.step1-child.selected .step1-qty-dec').trigger('click');
    });

    // ── Footer next button ────────────────────────────────────────────
    $('#cmb-footer-next-btn').on('click', function () {
        if ($(this).prop('disabled')) return;
        var step = parseInt($('.cmb-tab--active').data('step'));

        if (step === 1) {
            // Kod henüz doğrulanmadıysa: ilerleme yerine postnummer modalını aç
            if (!_postnummerOk) {
                openPostnummerGate();
                return;
            }
            var newVariantId  = $('.step1-child.selected').attr('data-variantid') || '';
            var boxChanged    = !_prevBoxVariantId || newVariantId !== _prevBoxVariantId;
            var step2HasState = $.trim($('#step2-summary').html()) !== '';
            showStep1Summary();
            _prevBoxVariantId = newVariantId;
            ftrQtyHide();

            if (boxChanged || !step2HasState) {
                $(".macron-qty").each(function () { $(this).text(0); });
                $('.step2-c').attr('data-totalqty', '0');
                var spaces = parseInt($('#step1').attr('data-productbundlespace')) || 0;
                $(".step2-selected-c").html('');
                for (var i = 0; i < spaces; i++) {
                    $(".step2-selected-c").append('<div class="step2-child-selected choose-image" style="cursor:unset"></div>');
                }
                $('.full-basket').hide();
                $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
                $('.step2-child .macron-qty-main').css('display', 'flex');
                $('.cross-icon-div').show();
                resetSummariesFrom(2);
            }
            setActiveTab(2);
            showOnlyStep(2);

        } else if (step === 2) {
            showStep2Summary();
            setActiveTab(3); showOnlyStep(3);

        } else if (step === 3) {
            if (_step3Mode === 'corporate') {
                showStep3Summary('Bedriftsomslag' + (_corpFileName ? ': ' + _corpFileName : ''), null);
            } else if (_step3Mode === 'preset-logo') {
                var hasCover = $('.cover-box.selected-cover-box').length > 0;
                var logoTag = _presetLogoFileName ? ' + logo' : '';
                if (hasCover) showStep3Summary(($('.selected-cover-box .step3-title').text() || 'Bedriftsdesign') + logoTag, $('.selected-cover-box .card-img-d').attr('src') || null);
                else { $('#no-thanks-cover').prop('checked', true).trigger('change'); showStep3Summary('Ingen omslag', null); }
            } else {
                var hasCover = $('.cover-box.selected-cover-box').length > 0;
                var logoSuffix = (_logoEnabled && _logoFileName) ? ' + logo' : (_logoEnabled ? ' + logo' : '');
                if (hasCover) showStep3Summary(($('.selected-cover-box .step3-title').text() || 'Omslag') + logoSuffix, $('.selected-cover-box .card-img-d').attr('src') || null);
                else { $('#no-thanks-cover').prop('checked', true).trigger('change'); showStep3Summary('Ingen omslag', null); }
            }
            setActiveTab(4); showOnlyStep(4);

        } else if (step === 4) {
            if (_step4Mode === 'corporate') {
                showStep4Summary('Bedriftskort' + (_card4CorpFileName ? ': ' + _card4CorpFileName : ''), null);
            } else if (_step4Mode === 'preset-logo') {
                var hasCard = $('.greeting-card.selected-card-box').length > 0;
                var logoTag = _card4PresetLogoFileName ? ' + logo' : '';
                if (hasCard) showStep4Summary(($('.selected-card-box .step3-title').text() || 'Bedriftskort') + logoTag, $('.selected-card-box .card-img-d').attr('src') || null);
                else { $('#no-thanks-card').prop('checked', true).trigger('change'); showStep4Summary('Ingen kort', null); }
            } else {
                var hasCard = $('.greeting-card.selected-card-box').length > 0;
                var logoSuffix = (_card4LogoEnabled && _card4LogoFileName) ? ' + logo' : (_card4LogoEnabled ? ' + logo' : '');
                if (hasCard) showStep4Summary(($('.selected-card-box .step3-title').text() || 'Kort') + logoSuffix, $('.selected-card-box .card-img-d').attr('src') || null);
                else { $('#no-thanks-card').prop('checked', true).trigger('change'); showStep4Summary('Ingen kort', null); }
            }
            setActiveTab(5); showOnlyStep(5);

        } else if (step === 5) {
            var hasMsg = $.trim($('#gift-message').val()) !== '';
            showStep5Summary(hasMsg ? 'Melding lagt til' : 'Ingen melding');
            setActiveTab(6);
            showOnlyStep(6);
        }
        price_calculate();
    });

    // ── Step 3: cover filter & selection ─────────────────────────────
    $(document).on('click', '.cover-filter-btn', function () {
        $('.cover-filter-btn').removeClass('active');
        $(this).addClass('active');
        // Clear cover selection when switching tema (guard: not a card-filter-btn)
        if (!$(this).hasClass('card-filter-btn')) {
            $('.cover-box').removeClass('selected-cover-box');
            $('.cover_box_input').prop('checked', false);
            clearStep3Preview();
            hideOmslagPreviewBtn();
            updateFooterBtn(3);
            price_calculate();
        }
        var filter = $(this).data('filter');
        var $covers = $('#step3-panel-ready .cover-box');
        if (filter === 'all') {
            $covers.show();
        } else {
            $covers.each(function () {
                $(this).toggle(($(this).data('tema') || '').indexOf(filter) !== -1);
            });
        }
    });

    $(document).on('click', '.cover-box', function (e) {
        if ($(e.target).is('.cover_box_input')) return;
        var $radio = $(this).find('.cover_box_input');
        if ($radio.is(':checked')) {
            $radio.prop('checked', false);
            $(this).removeClass('selected-cover-box');
            clearStep3Preview();
            hideOmslagPreviewBtn();
            updateFooterBtn(3);
            price_calculate();
            if (_step3Mode === 'preset-logo') {
                $('#preset-logo-addon-section').addClass('logo-upload-disabled');
            } else if (_step3Mode === 'ready') {
                $('#logo-addon-check').prop('checked', false);
                $('#logo-addon-fields').hide();
                _logoEnabled = false;
                _logoFileName = '';
                $('#logo-file-input').val('');
                $('#logo-filename').hide().text('');
                $('#logo-upload-zone .corp-upload-title, #logo-upload-zone .corp-upload-subtitle').show();
                $('#logo-upload-zone').removeClass('has-file');
                $('#ready-logo-addon-section').hide().addClass('logo-upload-disabled');
            }
            return false;
        }
    });
    $(".cover_box_input").change(function () {
        $(".cover-box").removeClass("selected-cover-box");
        var $label = $(this).parents(".cover-box").addClass("selected-cover-box");
        var handle = $label.data('handle') || '';
        var fallback = $label.find('.card-img-d').attr('src') || '';
        if (handle) showStep3Preview(handle, fallback);
        showOmslagPreviewBtn();
        updateFooterBtn(3);
        price_calculate();
        if (_step3Mode === 'preset-logo') {
            $('#preset-logo-addon-section').removeClass('logo-upload-disabled');
            if (window.innerWidth <= 640) {
                setTimeout(function() {
                    var top = $('#preset-logo-addon-section').offset().top;
                    $('html, body').animate({ scrollTop: Math.max(0, top - 80) }, 750);
                }, 200);
            }
        } else if (_step3Mode === 'ready') {
            $('#ready-logo-addon-section').removeClass('logo-upload-disabled');
        }
    });

    // ── Step 3: type tab switching ────────────────────────────────────
    $(document).on('click', '.step3-type-tab', function () {
        var panel = $(this).data('panel');
        if (panel === _step3Mode) return;
        _step3Mode = panel;
        $('.step3-type-tab').removeClass('active');
        $(this).addClass('active');
        $('#step3-panel-preset-logo, #step3-panel-corporate, #step3-panel-ready').hide();
        $(".cover-box").removeClass("selected-cover-box");
        $(".cover_box_input").prop('checked', false);
        clearStep3Preview();
        hideOmslagPreviewBtn();
        if (panel === 'corporate') {
            var corpPreviewSrc = 'https://cdn.shopify.com/s/files/1/0677/6854/9601/files/Image_06.png?v=1779226790';
            $('#step3-preview-img').attr('src', corpPreviewSrc).show();
            $('.step3-preview-placeholder').hide();
        }
        if (panel === 'ready') {
            $('#step3-panel-ready').show();
            $('#step3-panel-ready .cover-filter-btn').first().trigger('click');
            $('#preset-logo-addon-section').hide();
            $('#ready-logo-addon-section').show();
            _corpFileName = '';
            _corpNote = '';
            _presetLogoFileName = '';
            _presetLogoNote = '';
        } else if (panel === 'corporate') {
            $('#step3-panel-corporate').show();
            $('#preset-logo-addon-section').hide();
            $('#ready-logo-addon-section').hide();
            $('#logo-addon-check').prop('checked', false);
            $('#logo-addon-fields').hide();
            _logoEnabled = false;
            _logoFileName = '';
            _logoNote = '';
            _presetLogoFileName = '';
            _presetLogoNote = '';
        } else {
            $('#step3-panel-preset-logo').show();
            $('#preset-logo-addon-section').show();
            $('#ready-logo-addon-section').hide();
            $('#logo-addon-check').prop('checked', false);
            $('#logo-addon-fields').hide();
            _logoEnabled = false;
            _logoFileName = '';
            _logoNote = '';
            _corpFileName = '';
            _corpNote = '';
        }
        updateFooterBtn(3);
        price_calculate();
    });

    // ── Step 3: logo addon checkbox ───────────────────────────────────
    $(document).on('change', '#logo-addon-check', function () {
        _logoEnabled = $(this).is(':checked');
        if (_logoEnabled) {
            $('#logo-addon-fields').slideDown(200);
        } else {
            $('#logo-addon-fields').slideUp(200);
            _logoFileName = '';
            _logoNote = '';
            $('#logo-file-input').val('');
            $('#logo-filename').hide().text('');
            $('#logo-upload-zone .corp-upload-title, #logo-upload-zone .corp-upload-subtitle').show();
            $('#logo-upload-zone').removeClass('has-file');
        }
        price_calculate();
        updateFooterBtn(3);
    });

    // ── Step 3: logo file upload ──────────────────────────────────────
    $(document).on('click', '#logo-upload-zone', function (e) {
        if ($(e.target).is('input') || $(e.target).is('#logo-remove')) return;
        $('#logo-file-input').trigger('click');
    });
    $(document).on('change', '#logo-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _logoFileName = file.name;
        $('#logo-filename').text(file.name).show();
        $('#logo-upload-zone .corp-upload-title, #logo-upload-zone .corp-upload-subtitle').hide();
        $('#logo-upload-zone').addClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('click', '#logo-remove', function (e) {
        e.stopPropagation();
        _logoFileName = '';
        $('#logo-file-input').val('');
        $('#logo-filename').hide().text('');
        $('#logo-upload-zone .corp-upload-title, #logo-upload-zone .corp-upload-subtitle').show();
        $('#logo-upload-zone').removeClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('input', '#logo-note', function () {
        _logoNote = $(this).val();
    });

    // ── Step 3: preset-logo file upload ──────────────────────────────
    $(document).on('click', '#preset-logo-upload-zone', function (e) {
        if ($(e.target).is('input') || $(e.target).is('#preset-logo-remove')) return;
        $('#preset-logo-file-input').trigger('click');
    });
    $(document).on('change', '#preset-logo-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _presetLogoFileName = file.name;
        $('#preset-logo-filename').text(file.name).show();
        $('#preset-logo-upload-zone .corp-upload-title, #preset-logo-upload-zone .corp-upload-subtitle').hide();
        $('#preset-logo-upload-zone').addClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('click', '#preset-logo-remove', function (e) {
        e.stopPropagation();
        _presetLogoFileName = '';
        $('#preset-logo-file-input').val('');
        $('#preset-logo-filename').hide().text('');
        $('#preset-logo-upload-zone .corp-upload-title, #preset-logo-upload-zone .corp-upload-subtitle').show();
        $('#preset-logo-upload-zone').removeClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('input', '#preset-logo-note', function () {
        _presetLogoNote = $(this).val();
    });

    // ── Step 3: corporate file upload ─────────────────────────────────
    $(document).on('click', '#corp-upload-zone', function (e) {
        if ($(e.target).is('input') || $(e.target).is('#corp-remove')) return;
        $('#corp-file-input').trigger('click');
    });
    $(document).on('click', '#corp-remove', function (e) {
        e.stopPropagation();
        _corpFileName = '';
        $('#corp-file-input').val('');
        $('#corp-filename').hide().text('');
        $('#corp-upload-zone .corp-upload-title, #corp-upload-zone .corp-upload-subtitle').show();
        $('#corp-upload-zone').removeClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('change', '#corp-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _corpFileName = file.name;
        $('#corp-filename').text(file.name).show();
        $('#corp-upload-zone .corp-upload-title, #corp-upload-zone .corp-upload-subtitle').hide();
        $('#corp-upload-zone').addClass('has-file');
        updateFooterBtn(3);
    });
    $(document).on('input', '#corp-note', function () {
        _corpNote = $(this).val();
    });

    // ── Step 4: type tab switching ────────────────────────────────────
    $(document).on('click', '.step4-type-tab', function () {
        var panel = $(this).data('panel');
        if (panel === _step4Mode) return;
        _step4Mode = panel;
        $('.step4-type-tab').removeClass('active');
        $(this).addClass('active');
        $('#step4-panel-preset-logo, #step4-panel-corporate, #step4-panel-ready').hide();
        $(".greeting-card").removeClass("selected-card-box");
        $(".greeting_card_input").prop('checked', false);
        if (panel === 'ready') {
            $('#step4-panel-ready').show();
            _card4CorpFileName = '';
            _card4CorpNote = '';
            _card4PresetLogoFileName = '';
            _card4PresetLogoNote = '';
        } else if (panel === 'corporate') {
            $('#step4-panel-corporate').show();
            $('#card-logo-addon-check').prop('checked', false);
            $('#card-logo-addon-fields').hide();
            _card4LogoEnabled = false;
            _card4LogoFileName = '';
            _card4LogoNote = '';
            _card4PresetLogoFileName = '';
            _card4PresetLogoNote = '';
        } else {
            $('#step4-panel-preset-logo').show();
            $('#card-logo-addon-check').prop('checked', false);
            $('#card-logo-addon-fields').hide();
            _card4LogoEnabled = false;
            _card4LogoFileName = '';
            _card4LogoNote = '';
            _card4CorpFileName = '';
            _card4CorpNote = '';
        }
        updateFooterBtn(4);
        price_calculate();
    });

    // ── Step 4: card filter buttons ───────────────────────────────────
    $(document).on('click', '.card-filter-btn', function () {
        $('.card-filter-btn').removeClass('active');
        $(this).addClass('active');
        var filter = $(this).data('filter');
        if (filter === 'all') {
            $('#step4-panel-ready .greeting-card').show();
        } else {
            $('#step4-panel-ready .greeting-card').each(function () {
                $(this).toggle(($(this).data('tema') || '').indexOf(filter) !== -1);
            });
        }
    });

    // ── Step 4: card selection ────────────────────────────────────────
    $(document).on('click', '.greeting-card', function (e) {
        if ($(e.target).is('.greeting_card_input')) return;
        var $radio = $(this).find('.greeting_card_input');
        if ($radio.is(':checked')) {
            $radio.prop('checked', false);
            $(this).removeClass('selected-card-box');
            if (_step4Mode === 'preset-logo') {
                $('#step4-panel-preset-logo .logo-addon-section').addClass('logo-upload-disabled');
            } else if (_step4Mode === 'ready') {
                $('#card-logo-addon-check').prop('checked', false);
                $('#card-logo-addon-fields').hide();
                _card4LogoEnabled = false;
                _card4LogoFileName = '';
                $('#card-logo-file-input').val('');
                $('#card-logo-filename').hide().text('');
                $('#card-logo-upload-zone .corp-upload-title, #card-logo-upload-zone .corp-upload-subtitle').show();
                $('#card-logo-upload-zone').removeClass('has-file');
                $('#step4-panel-ready .logo-addon-section').addClass('logo-upload-disabled');
            }
            updateFooterBtn(4);
            price_calculate();
            return false;
        }
    });
    $(document).on('change', '.greeting_card_input', function () {
        $(".greeting-card").removeClass("selected-card-box");
        $(this).parents(".greeting-card").addClass("selected-card-box");
        updateFooterBtn(4);
        price_calculate();
        if (_step4Mode === 'preset-logo') {
            $('#step4-panel-preset-logo .logo-addon-section').removeClass('logo-upload-disabled');
            var $logoSection = $('#step4-panel-preset-logo .logo-addon-section');
            if ($logoSection.length) {
                setTimeout(function () {
                    var targetTop = $logoSection.offset().top - $(window).height() * 0.45;
                    $('html, body').animate({ scrollTop: Math.max(0, targetTop) }, 400);
                }, 150);
            }
        } else if (_step4Mode === 'ready') {
            $('#step4-panel-ready .logo-addon-section').removeClass('logo-upload-disabled');
            var $readyLogoSection = $('#step4-panel-ready .logo-addon-section');
            if ($readyLogoSection.length) {
                setTimeout(function () {
                    var targetTop = $readyLogoSection.offset().top - $(window).height() * 0.55;
                    $('html, body').animate({ scrollTop: Math.max(0, targetTop) }, 400);
                }, 150);
            }
        }
    });

    // ── Step 4: logo addon checkbox ───────────────────────────────────
    $(document).on('change', '#card-logo-addon-check', function () {
        _card4LogoEnabled = $(this).is(':checked');
        if (_card4LogoEnabled) {
            $('#card-logo-addon-fields').slideDown(200);
        } else {
            $('#card-logo-addon-fields').slideUp(200);
            _card4LogoFileName = '';
            _card4LogoNote = '';
            $('#card-logo-file-input').val('');
            $('#card-logo-filename').hide().text('');
            $('#card-logo-upload-zone .corp-upload-title, #card-logo-upload-zone .corp-upload-subtitle').show();
            $('#card-logo-upload-zone').removeClass('has-file');
        }
        price_calculate();
        updateFooterBtn(4);
    });

    // ── Step 4: logo file upload (ready panel) ────────────────────────
    $(document).on('click', '#card-logo-upload-zone', function (e) {
        if ($(e.target).is('input') || $(e.target).is('#card-logo-remove')) return;
        $('#card-logo-file-input').trigger('click');
    });
    $(document).on('change', '#card-logo-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _card4LogoFileName = file.name;
        $('#card-logo-filename').text(file.name).show();
        $('#card-logo-upload-zone .corp-upload-title, #card-logo-upload-zone .corp-upload-subtitle').hide();
        $('#card-logo-upload-zone').addClass('has-file');
        updateFooterBtn(4);
    });
    $(document).on('click', '#card-logo-remove', function (e) {
        e.stopPropagation();
        _card4LogoFileName = '';
        $('#card-logo-file-input').val('');
        $('#card-logo-filename').hide().text('');
        $('#card-logo-upload-zone .corp-upload-title, #card-logo-upload-zone .corp-upload-subtitle').show();
        $('#card-logo-upload-zone').removeClass('has-file');
        updateFooterBtn(4);
    });
    $(document).on('input', '#card-logo-note', function () {
        _card4LogoNote = $(this).val();
    });

    // ── Step 4: preset-logo file upload ──────────────────────────────
    $(document).on('click', '#preset-card-logo-upload-zone', function (e) {
        if ($(e.target).is('input') || $(e.target).is('#preset-card-logo-remove')) return;
        $('#preset-card-logo-file-input').trigger('click');
    });
    $(document).on('change', '#preset-card-logo-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _card4PresetLogoFileName = file.name;
        $('#preset-card-logo-filename').text(file.name).show();
        $('#preset-card-logo-upload-zone .corp-upload-title, #preset-card-logo-upload-zone .corp-upload-subtitle').hide();
        $('#preset-card-logo-upload-zone').addClass('has-file');
        updateFooterBtn(4);
    });
    $(document).on('click', '#preset-card-logo-remove', function (e) {
        e.stopPropagation();
        _card4PresetLogoFileName = '';
        $('#preset-card-logo-file-input').val('');
        $('#preset-card-logo-filename').hide().text('');
        $('#preset-card-logo-upload-zone .corp-upload-title, #preset-card-logo-upload-zone .corp-upload-subtitle').show();
        $('#preset-card-logo-upload-zone').removeClass('has-file');
        updateFooterBtn(4);
    });
    $(document).on('input', '#preset-card-logo-note', function () {
        _card4PresetLogoNote = $(this).val();
    });

    // ── Step 4: corporate file upload ─────────────────────────────────
    $(document).on('click', '#card-corp-upload-zone', function (e) {
        if ($(e.target).is('input')) return;
        $('#card-corp-file-input').trigger('click');
    });
    $(document).on('change', '#card-corp-file-input', function () {
        var file = this.files[0];
        if (!file) return;
        _card4CorpFileName = file.name;
        $('#card-corp-filename').text(file.name).show();
        $('#card-corp-upload-zone .corp-upload-title, #card-corp-upload-zone .corp-upload-subtitle').hide();
        $('#card-corp-upload-zone').addClass('has-file');
    });
    $(document).on('input', '#card-corp-note', function () {
        _card4CorpNote = $(this).val();
    });

    // ── Step 2: reset basket ──────────────────────────────────────────
    function resetStep2Basket() {
        $('.full-basket').hide();
        $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
        $('.step2-child .macron-qty-main').css('display', 'flex');
        $('.cross-icon-div').show();
        $('.step2-c').attr('data-totalqty', '0');
        $(".macron-qty").each(function () { $(this).text(0); });
        $(".step2-child-selected").each(function () { $(this).addClass('choose-image').html(''); });
        $('.preset-card').removeClass('active');
    }

    $("#reset-btn").click(function () {
        resetStep2Basket();
        updateFooterBtn(2);
        price_calculate();
    });

    // ── Step 2: Preset combinations ───────────────────────────────────
    function applyPreset(preset) {
        resetStep2Basket();

        var boxSize = parseInt($('#step1').attr('data-productbundlespace')) || 12;
        var $macrons = $('.step2-child');
        var totalMacrons = $macrons.length;
        if (totalMacrons === 0) { updateFooterBtn(2); price_calculate(); return; }

        var picks = [];
        var slotCount, baseQty, rem, i;

        if (preset === 'popular') {
            slotCount = Math.min(4, totalMacrons);
            baseQty = Math.floor(boxSize / slotCount);
            rem = boxSize % slotCount;
            for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: baseQty + (i < rem ? 1 : 0) });
        } else if (preset === 'classic') {
            slotCount = Math.min(3, totalMacrons);
            baseQty = Math.floor(boxSize / slotCount);
            rem = boxSize % slotCount;
            for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: baseQty + (i < rem ? 1 : 0) });
        } else if (preset === 'seasonal') {
            slotCount = Math.min(4, totalMacrons);
            baseQty = Math.floor(boxSize / slotCount);
            rem = boxSize % slotCount;
            for (i = 0; i < slotCount; i++) picks.push({ idx: totalMacrons - slotCount + i, qty: baseQty + (i < rem ? 1 : 0) });
        } else if (preset === 'adventure') {
            slotCount = Math.min(boxSize, totalMacrons);
            for (i = 0; i < slotCount; i++) picks.push({ idx: i, qty: 1 });
            var remaining = boxSize - slotCount;
            for (i = 0; i < remaining; i++) picks[i % slotCount].qty += 1;
        }

        picks.forEach(function (p) {
            var $inc = $macrons.eq(p.idx).find('.macron-increment');
            for (var j = 0; j < p.qty; j++) $inc.trigger('click');
        });

        // Re-enable basket panel and cross icons so items can be removed after preset fills the box
        $('.step2-main21').css('pointer-events', 'auto');
        $('.cross-icon-div').show();
        $('.preset-card[data-preset="' + preset + '"]').addClass('active');
        updateFtrMacronStrip();
        updateFooterBtn(2);
        price_calculate();
    }

    $(document).on('click', '.preset-card', function () {
        applyPreset($(this).data('preset'));
    });

    // ── Sammendrag: slett alle og begynn på nytt ──────────────────────
    $('#cmb-reset-all-btn').on('click', fullReset);
    $("#change_box_size").click(fullReset);

    // ── Macaron decrement / increment ─────────────────────────────────
    $(".macron-decrement").click(function () {
        var qty = parseInt($(this).next('.macron-qty').text());
        if (qty === 0) return;
        $('.preset-card').removeClass('active');
        $(this).next('.macron-qty').text(qty - 1);
        var total = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', total);
        var id    = $(this).parents(".step2-child").attr('data-ids');
        $('.cross-icon[data-crossid="' + id + '"]').last().parents('.step2-child-selected').addClass('choose-image').html('');
        updateFtrMacronStrip();
        updateFooterBtn(2);
        price_calculate();
    });

    $(document).on('click', ".macron-increment", function (e) {
        e.preventDefault();
        var qty   = parseInt($(this).prev('.macron-qty').text());
        var total = parseInt($('.step2-c').attr('data-totalqty'));
        var max   = parseInt($('#step1').attr('data-productbundlespace'));
        if (total < max) {
            $('.preset-card').removeClass('active');
            $('.step2-c').attr('data-totalqty', total + 1);
            $(this).prev('.macron-qty').text(qty + 1);
            var $product   = $(this).closest('.step2-child');
            var $emptySlot = $('.step2-child-selected').filter(function () { return $(this).find('img').length === 0; }).first();
            if ($emptySlot.length) {
                var mName = $product.find('.macron-name').text();
                $emptySlot.removeClass("choose-image").html(
                    '<div class="macron-temp-div" data-macronname="' + mName + '">'
                    + '<img class="card-img-e" alt="" src="' + $product.data('image') + '">'
                    + '<div class="cross-icon-div"><p data-crossid="' + $product.attr('data-id') + '" class="cross-icon">×</p></div>'
                    + '<p class="basket-macron-name">' + mName + '</p>'
                    + '</div>'
                );
            }
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
        if (total + 1 === max && window.innerWidth <= 640) flashKurvBtn();
        price_calculate();
    });

    $(document).on('click', ".macron-qty", function (e) { e.preventDefault(); });

    // ── Cross icon ────────────────────────────────────────────────────
    $(document).on('click', ".cross-icon", function () {
        $('.preset-card').removeClass('active');
        var id       = $(this).attr('data-crossid');
        var $cell    = $("[data-ids='" + id + "']");
        $cell.find('.macron-qty').text(parseInt($cell.find('.macron-qty').text()) - 1);
        var newTotal = parseInt($('.step2-c').attr('data-totalqty')) - 1;
        $('.step2-c').attr('data-totalqty', newTotal);
        $(this).parents('.step2-child-selected').addClass('choose-image');
        $(this).parents('.macron-temp-div').remove();
        var max = parseInt($('#step1').attr('data-productbundlespace')) || 0;
        if (newTotal < max) {
            $('.full-basket').hide();
            $('.step2-main1, .step2-main21').css('pointer-events', 'unset');
            $('.step2-child .macron-qty-main').css('display', 'flex');
            $('.cross-icon-div').show();
        }
        updateFtrMacronStrip();
        updateFooterBtn(2);
    });

    // ── Gift message ──────────────────────────────────────────────────
    $(document).on('keyup', '#gift-message', function () { price_calculate(); updateFooterBtn(5); });
    var giftMessage         = document.getElementById('gift-message');
    var remainingCharacters = document.getElementById('remaining-characters');
    if (giftMessage && remainingCharacters) {
        giftMessage.addEventListener('input', function () {
            var max = 200;
            if (this.value.length > max) this.value = this.value.substring(0, max);
            remainingCharacters.textContent = (max - this.value.length) + ' tegn igjen';
        });
    }

    // ── Incomplete step modal ─────────────────────────────────────────
    var _incompleteStep = 0;
    $('#incomplete-step-overlay, #incomplete-step-go').on('click', function () {
        $('#incomplete-step-modal').fadeOut(200);
        if ($(this).is('#incomplete-step-go') && _incompleteStep) window.editStep(_incompleteStep);
    });

    // ── Step completeness guard (shared by both checkout paths) ───────
    function allStepsComplete() {
        var stepLabels = {
            1: 'Velg boks (steg 1)', 2: 'Velg makroner (steg 2)',
            3: 'Velg omslag (steg 3)', 4: 'Velg hilsenkort (steg 4)', 5: 'Legg til melding (steg 5)'
        };
        for (var s = 1; s <= 5; s++) {
            if (!$('#step' + s + '-summary').length || $.trim($('#step' + s + '-summary').html()) === '') {
                _incompleteStep = s;
                $('#incomplete-step-msg').text(stepLabels[s] + ' er ikke fullført. Gå tilbake og fullfør dette steget for å fortsette.');
                $('#incomplete-step-modal').fadeIn(200);
                return false;
            }
        }
        return true;
    }

    // ── Add to cart (Betal nå → standard checkout) ────────────────────
    $(document).on('click', '#add_box_to_card', function () {
        if (!allStepsComplete()) return;
        $(".container-c2").show();
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function () {
            $(".container-c2").hide();
            if (window.CartDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
            else window.location.href = '/cart';
        })
        .catch(function (error) {
            $(".container-c2").hide();
            console.error('Cart error:', error);
        });
    });

    // ── Custom (logo/eget design) → leveringstid min 3 uker ───────────
    function fgStep3Custom() {
        if (_step3Mode === 'corporate')   return !!$('#corp-cover-variant-id').val();
        if (_step3Mode === 'preset-logo') {
            var v = $('#step3-panel-preset-logo .cover_box_input:checked').val();
            return !!_presetLogoFileName || (!!v && v !== 'no');
        }
        return _logoEnabled === true; // ready + logo addon
    }
    function fgStep4Custom() {
        if (_step4Mode === 'corporate')   return !!$('#card-corp-variant-id').val();
        if (_step4Mode === 'preset-logo') {
            var v = $('#step4-panel-preset-logo .greeting_card_input:checked').val();
            return !!_card4PresetLogoFileName || (!!v && v !== 'no');
        }
        return _card4LogoEnabled === true; // ready + logo addon
    }
    function fgIsCustom() { return fgStep3Custom() || fgStep4Custom(); }

    function fgUpdateDeliveryNotice() {
        $('.fg-custom-delivery-note[data-step="3"]').toggle(fgStep3Custom());
        $('.fg-custom-delivery-note[data-step="4"]').toggle(fgStep4Custom());
    }
    // Mevcut handler'lara dokunmadan; setTimeout(0) ile state set olduktan sonra çalışır
    $(document).on('click', '.step3-type-tab, .step4-type-tab, .corp-upload-remove', function () { setTimeout(fgUpdateDeliveryNotice, 0); });
    $(document).on('change',
        '#logo-addon-check, #card-logo-addon-check, .cover_box_input, .greeting_card_input, ' +
        '#preset-logo-file-input, #preset-card-logo-file-input, #corp-file-input, #card-corp-file-input, ' +
        '#logo-file-input, #card-logo-file-input',
        function () { setTimeout(fgUpdateDeliveryNotice, 0); });

    function fgFmtDate(d) {
        var dd = ('0' + d.getDate()).slice(-2), mm = ('0' + (d.getMonth() + 1)).slice(-2);
        return dd + '.' + mm + '.' + d.getFullYear();
    }
    function fgMinDeliveryISO() {
        var weeks = fgIsCustom() ? 3 : 1;
        var d = new Date(); d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + weeks * 7);
        return { iso: d.toISOString().slice(0, 10), display: fgFmtDate(d), weeks: weeks };
    }

    // ── Norske helligdager (røde dager) + datovelger ──────────────────
    function fgEaster(y) {
        var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4),
            e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
            h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
            l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
            mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(y, mo - 1, da);
    }
    function fgIso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function fgAddDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
    function fgHolidaysForYear(y) {
        var e = fgEaster(y);
        return [
            new Date(y, 0, 1),      // Nyttårsdag
            fgAddDays(e, -3),       // Skjærtorsdag
            fgAddDays(e, -2),       // Langfredag
            e,                      // 1. påskedag
            fgAddDays(e, 1),        // 2. påskedag
            new Date(y, 4, 1),      // Arbeidernes dag
            new Date(y, 4, 17),     // Grunnlovsdag
            fgAddDays(e, 39),       // Kristi himmelfartsdag
            fgAddDays(e, 49),       // 1. pinsedag
            fgAddDays(e, 50),       // 2. pinsedag
            new Date(y, 11, 25),    // 1. juledag
            new Date(y, 11, 26)     // 2. juledag
        ].map(fgIso);
    }
    var _fgHolidays = (function () {
        var now = new Date().getFullYear(), out = [];
        for (var y = now; y <= now + 2; y++) out = out.concat(fgHolidaysForYear(y));
        return out;
    })();
    function fgIsBlockedDate(iso) {
        if (!iso) return false;
        var g = new Date(iso + 'T00:00:00').getDay();
        if (g === 0 || g === 6) return true;            // helg
        return _fgHolidays.indexOf(iso) !== -1;          // rød dag
    }
    // Første hverdag (ikke helg/helligdag) minst `days` fram i tid
    function fgEarliestDelivery(days) {
        var d = new Date(); d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + days);
        while (fgIsBlockedDate(fgIso(d))) d.setDate(d.getDate() + 1);
        return d;
    }
    var _fgPicker = null;
    function fgInitDatePicker() {
        if (_fgPicker || !window.flatpickr) return;
        var el = document.getElementById('fk-date');
        if (!el) return;
        _fgPicker = window.flatpickr(el, {
            dateFormat: 'Y-m-d',
            disableMobile: true,                         // tvinger flatpickr-UI (helg/helligdag deaktiveres også mobilt)
            locale: {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                    longhand: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag']
                },
                months: {
                    shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
                    longhand: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember']
                },
                rangeSeparator: ' til ',
                weekAbbreviation: 'Uke',
                scrollTitle: 'Scroll for å endre',
                toggleTitle: 'Klikk for å veksle',
                ordinal: function () { return '.'; }
            },
            disable: [function (d) { var g = d.getDay(); return g === 0 || g === 6; }].concat(_fgHolidays)
        });
    }

    // ── Firmagave: logo/illustrasjon opplasting (ved valg) ────────────
    var fgUploadEndpoint = ($('#add-to-card-div').data('faktura-endpoint') || '').replace(/\/order$/, '/upload');
    var FG_SLOTS = {
        'logo-file-input':             'logo',
        'corp-file-input':             'corp',
        'preset-logo-file-input':      'presetLogo',
        'card-logo-file-input':        'card4Logo',
        'card-corp-file-input':        'card4Corp',
        'preset-card-logo-file-input': 'card4PresetLogo'
    };
    function fgFilenameEl(inputId) { return $('#' + inputId.replace('-file-input', '-filename')); }
    function fgFileProp(slot, fallbackName) {
        if (fgFileUrls[slot] && fgFileUrls[slot].url) return fgFileUrls[slot].url;
        return fallbackName || 'Ikke lastet opp';
    }
    // Egne change-listeners (i tillegg til de eksisterende som setter filnavn/UI)
    $(document).on('change',
        '#logo-file-input, #corp-file-input, #preset-logo-file-input, ' +
        '#card-logo-file-input, #card-corp-file-input, #preset-card-logo-file-input',
        function () {
            var slot = FG_SLOTS[this.id], file = this.files[0];
            if (!slot || !file) return;
            var $fn = fgFilenameEl(this.id);
            delete fgFileUrls[slot];
            $fn.text(file.name + ' — laster opp …').show();
            var fd = new FormData();
            fd.append('file', file);
            fetch(fgUploadEndpoint, { method: 'POST', body: fd })
                .then(function (r) { return r.json().catch(function () { return {}; }); })
                .then(function (res) {
                    if (res && res.ok && res.url) {
                        fgFileUrls[slot] = { url: res.url, name: res.filename || file.name };
                        $fn.text((res.filename || file.name) + ' ✓').show();
                    } else {
                        $fn.text((res && res.error ? res.error : (file.name + ' — opplasting feilet'))).show();
                    }
                })
                .catch(function () { $fn.text(file.name + ' — opplasting feilet, prøv igjen').show(); });
        });
    $(document).on('click',
        '#logo-remove, #corp-remove, #preset-logo-remove, #card-logo-remove, #preset-card-logo-remove',
        function () { var s = FG_SLOTS[this.id.replace('-remove', '-file-input')]; if (s) delete fgFileUrls[s]; });

    // ── Bestill mot faktura (draft order via backend) ─────────────────
    $(document).on('click', '#bestill_faktura_btn', function () {
        if (!allStepsComplete()) return;
        $('#faktura-error').hide().text('');
        // Prefyll postnummer fra leveringssjekk om tilgjengelig
        var pn = $.trim($('#postnummer-input').val() || '');
        if (pn && !$('#fk-zip').val()) $('#fk-zip').val(pn);
        // Leveringsdato: min 3 uker ved logo/eget design, ellers 1 uke; helg/helligdag sperret
        fgInitDatePicker();
        var md = fgMinDeliveryISO();
        if (_fgPicker) {
            _fgPicker.set('minDate', md.iso);
            var cur = _fgPicker.selectedDates[0];
            if (cur && fgIso(cur) < md.iso) _fgPicker.clear();
        } else {
            // Fallback hvis flatpickr ikke lastet: la feltet skrives manuelt
            $('#fk-date').prop('readonly', false).attr('min', md.iso);
            if ($('#fk-date').val() && $('#fk-date').val() < md.iso) $('#fk-date').val('');
        }
        $('#fk-date-hint').text((md.weeks === 3
            ? 'Tidligst ' + md.display + ' — minimum 3 uker ved logo/eget design.'
            : 'Tidligst ' + md.display + ' — ca. 1 uke.') + ' Levering kl. 10:30–16:00. Helg og helligdager er ikke tilgjengelig.');
        $('#faktura-modal').fadeIn(200);
    });

    $('#faktura-close, #faktura-overlay').on('click', function () { $('#faktura-modal').fadeOut(200); });
    $('#faktura-success-close, #faktura-success-overlay').on('click', function () { $('#faktura-success').fadeOut(200); });

    $(document).on('submit', '#faktura-form', function (e) {
        e.preventDefault();
        var $err = $('#faktura-error');
        var val = function (id) { return $.trim($('#' + id).val() || ''); };

        var company   = val('fk-company');
        var orgnr     = val('fk-orgnr').replace(/\s+/g, '');
        var contact   = val('fk-contact');
        var email     = val('fk-email');
        var phone     = val('fk-phone');
        var address   = val('fk-address');
        var zip       = val('fk-zip');
        var city      = val('fk-city');

        if (!company || !orgnr || !contact || !email || !phone || !address || !zip || !city) {
            $err.text('Fyll inn alle obligatoriske felter.').show(); return;
        }
        if (!/^\d{9}$/.test(orgnr)) {
            $err.text('Organisasjonsnummer må være 9 siffer.').show(); return;
        }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            $err.text('Ugyldig e-postadresse.').show(); return;
        }
        if (!/^\d{4}$/.test(zip)) {
            $err.text('Postnummer må være 4 siffer.').show(); return;
        }
        // Leveringsdato: obligatorisk, ikke før tidligst mulig, ikke helg/helligdag
        var md = fgMinDeliveryISO();
        var dDate = val('fk-date');
        if (!dDate) {
            $err.text('Velg ønsket leveringsdato.').show(); return;
        }
        if (dDate < md.iso) {
            $err.text(md.weeks === 3
                ? 'Ved logo/eget design er tidligste leveringsdato ' + md.display + ' (minimum 3 uker).'
                : 'Tidligste leveringsdato er ' + md.display + '.').show();
            return;
        }
        if (fgIsBlockedDate(dDate)) {
            $err.text('Valgt dato er helg eller helligdag. Velg en hverdag.').show(); return;
        }

        // Sørg for at items reflekterer endelig valg
        price_calculate();
        if (!items.length) { $err.text('Noe gikk galt med boksinnholdet. Prøv på nytt.').show(); return; }

        var endpoint = $('#add-to-card-div').data('faktura-endpoint');
        var payload = {
            source: 'firmagave',
            shop_domain: (window.Shopify && window.Shopify.shop) || '',
            items: items,
            company: {
                company_name:   company,
                org_number:     orgnr,
                contact_person: contact,
                invoice_email:  email,
                phone:          phone,
                invoice_type:   $('input[name="invoice_type"]:checked').val() || 'EHF'
            },
            delivery: {
                address:       address,
                zip:           zip,
                city:          city,
                delivery_date: dDate
            },
            custom_print:       md.weeks === 3,
            min_delivery_weeks: md.weeks,
            po_reference: val('fk-ref'),
            gift_message: $.trim($('#gift-message').val() || '')
        };

        var $submit = $('#faktura-submit');
        $submit.prop('disabled', true).text('Sender …');

        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
        .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json().catch(function () { return {}; });
        })
        .then(function () {
            $submit.prop('disabled', false).text('Send bestilling');
            $('#faktura-modal').fadeOut(150);
            $('#faktura-success-email').text(email);
            $('#faktura-success').fadeIn(200);
            $('#faktura-form')[0].reset();
        })
        .catch(function (error) {
            console.error('Faktura order error:', error);
            $submit.prop('disabled', false).text('Send bestilling');
            $err.text('Kunne ikke sende bestillingen. Prøv igjen, eller kontakt oss på hello@meribel.no.').show();
        });
    });

    // ── Macaron info modal ────────────────────────────────────────────
    $(document).on('click', '.card-img-e', function () {
        if ($(this).closest('.step2-child-selected').length > 0) return;
        var $t = $(this);
        $('.modal-macron-img').attr('src', $t.attr('data-image'));
        $('.modal-macron-text').text($t.attr('data-name'));
        $('.modal-macron-description').text($t.attr('data-description'));
        $('.ingredient-p').text($t.attr('data-ingredient'));
        $('.allergy-p').text($t.attr('data-allergy'));
        $('.overlay').css({ display: 'flex', opacity: 0 }).animate({ opacity: 1 }, 400);
    });
    $('.close-btn').click(function () { $('.overlay').fadeOut(); });

    $(document).on('click', '.accordion-header', function () {
        var $action = $(this).find('.data-action-c');
        $action.text($action.text() === '+' ? '-' : '+');
        $(this).next('.accordion-collapse').toggleClass('show');
        $(this).toggleClass('collapsed');
    });

    // ── Macaron summary grid ──────────────────────────────────────────
    function renderMacronSummary() {
        var isMobile = window.innerWidth <= 640;
        var html = '';
        if (isMobile) {
            var counts = {}, imgs = {}, order = [];
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                if (!counts[name]) { counts[name] = 0; imgs[name] = src; order.push(name); }
                counts[name]++;
            });
            if (!order.length) { $('#macron-summary-section').hide(); return; }
            order.forEach(function(name) {
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + imgs[name] + '" alt="' + name + '">'
                      + (counts[name] > 1 ? '<span class="macron-sum-qty">×' + counts[name] + '</span>' : '')
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        } else {
            $('.macron-temp-div').each(function() {
                var name = $(this).data('macronname') || '';
                var src  = $(this).find('img').attr('src') || '';
                if (!name) return;
                html += '<div class="macron-sum-card">'
                      + '<div class="macron-sum-img-wrap">'
                      + '<img class="macron-sum-img" src="' + src + '" alt="' + name + '">'
                      + '</div>'
                      + '<p class="macron-sum-name">' + name + '</p>'
                      + '</div>';
            });
        }
        if (!html) { $('#macron-summary-section').hide(); return; }
        $('#macron-summary-grid').html(html);
        $('#macron-summary-section').show();
    }

    // ── Price calculation ─────────────────────────────────────────────
    function price_calculate() {
        items = [];
        var gift_box_price   = 0;
        var logo_price       = 0;
        var corp_cover_price = 0;
        var card_logo_price  = 0;
        var card_corp_price  = 0;
        var greeting_card_price = 0;

        if (_step3Mode === 'corporate') {
            corp_cover_price = parseFloat($('#corp-cover-variant-id').data('price') || 0);
        } else {
            gift_box_price = parseFloat($('.cover_box_input[type="radio"]:checked').attr('data-price') || 0);
            if (_logoEnabled) logo_price = parseFloat($('#logo-variant-id').data('price') || 0);
        }

        if (_step4Mode === 'corporate') {
            card_corp_price = parseFloat($('#card-corp-variant-id').data('price') || 0);
        } else {
            greeting_card_price = parseFloat($('.greeting_card_input[type="radio"]:checked').attr('data-price') || 0);
            if (_step4Mode === 'ready' && _card4LogoEnabled) card_logo_price = parseFloat($('#card-logo-variant-id').data('price') || 0);
        }

        var bundle_price = parseFloat($('#step1').attr('data-bundleproductprice') || 0);
        var total_price  = (greeting_card_price + gift_box_price + logo_price + corp_cover_price + card_logo_price + card_corp_price + bundle_price) * _boxQty;

        var stripItems = [];
        var boxImg     = $('.step1-child.selected').attr('data-image') || '';
        var boxTitle   = $('#step1').attr('data-bundleproducttitle') || '';
        if (boxTitle) stripItems.push({ img: boxImg, title: boxTitle, price: bundle_price });

        if (_step3Mode === 'corporate') {
            var corpId = $('#corp-cover-variant-id').val();
            if (corpId) stripItems.push({ img: '', title: 'Bedriftsomslag', price: corp_cover_price });
        } else {
            var coverVal = $('.cover_box_input[type="radio"]:checked').val();
            if (coverVal && coverVal !== 'no') stripItems.push({ img: $('.selected-cover-box .card-img-d').attr('src') || '', title: $('.selected-cover-box .step3-title').text() || 'Omslag', price: gift_box_price });
            if (_logoEnabled) stripItems.push({ img: '', title: 'Logo', price: logo_price });
        }

        if (_step4Mode === 'corporate') {
            var cardCorpId = $('#card-corp-variant-id').val();
            if (cardCorpId) stripItems.push({ img: '', title: 'Bedriftskort', price: card_corp_price });
        } else {
            var cardVal = $('.greeting_card_input[type="radio"]:checked').val();
            if (cardVal && cardVal !== 'no') stripItems.push({ img: $('.selected-card-box .card-img-d').attr('src') || '', title: $('.selected-card-box .step3-title').text() || 'Kort', price: greeting_card_price });
            if (_step4Mode === 'ready' && _card4LogoEnabled) stripItems.push({ img: '', title: 'Logo på kort', price: card_logo_price });
        }

        if ($.trim($('#gift-message').val()) !== '') stripItems.push({ type: 'message', title: 'Melding', price: 'Gratis' });

        var msgIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>';
        var stripHtml  = '';
        stripItems.forEach(function (item, i) {
            if (i > 0) stripHtml += '<span class="summary-sep">+</span>';
            var mediaHtml = item.type === 'message'
                ? '<div class="summary-img-wrap summary-icon-wrap">' + msgIconSvg + '</div>'
                : (item.img ? '<div class="summary-img-wrap"><img class="summary-img" src="' + item.img + '" alt=""></div>' : '');
            var priceHtml = item.type === 'message'
                ? '<p class="summary-item-price summary-gratis">Gratis</p>'
                : '<p class="summary-item-price">' + item.price.toFixed(0) + ',-</p>';
            stripHtml += '<div class="summary-item">' + mediaHtml + '<p class="summary-item-title">' + item.title + '</p>' + priceHtml + '</div>';
        });
        if (stripItems.length) {
            stripHtml += '<div class="summary-eq-block">'
                + '<span class="summary-sep">=</span>'
                + '<div class="summary-total-block">'
                + '<p class="summary-total-label">Totalt &middot; ' + _boxQty + ' esker</p>'
                + '<p class="summary-total-price">' + total_price.toFixed(0) + ' kr</p>'
                + '</div>'
                + '</div>';
        }
        $('#order-summary-strip').html(stripHtml);
        // firmagave: tüm kutular gaveeske → Oslo bud teslimat notu (ürün varken göster)
        $('#summary-delivery-note').toggle(stripItems.length > 0);

        var selected_bundle_id = $('#step1').attr('data-bundleproductvariantid');
        var macronNameCount    = {};
        $('.macron-temp-div').each(function () {
            var name = $(this).data('macronname');
            macronNameCount[name] = (macronNameCount[name] || 0) + 1;
        });
        var resultArray = [];
        $.each(macronNameCount, function (name, count) { resultArray.push(count + ' x ' + name); });

        var message    = $('#gift-message').val();
        var properties = {};
        resultArray.forEach(function (el, i) { properties["Makron#" + (i + 1)] = el; });
        properties["Gift Message"] = message;

        var greeting_card_id = $('.greeting_card_input[type="radio"]:checked').val();

        var messageEl = document.getElementById('dynamic-message');
        if (messageEl) {
            messageEl.textContent = greeting_card_id === 'no'
                ? "Meldingen din vil bli skrevet på en etikett og lagt i boksen, helt gratis."
                : "Meldingen din vil bli skrevet på baksiden av kortet du har valgt.";
        }

        if (selected_bundle_id !== undefined) items.push({ id: selected_bundle_id, quantity: _boxQty, properties: properties });

        if (_step3Mode === 'corporate') {
            var corpCoverId = $('#corp-cover-variant-id').val();
            if (corpCoverId) items.push({ id: corpCoverId, quantity: _boxQty, properties: { 'Designfil': fgFileProp('corp', _corpFileName), 'Notater': _corpNote || '' } });
        } else {
            var cover_box_id = $('.cover_box_input[type="radio"]:checked').val();
            if (cover_box_id !== undefined && cover_box_id !== 'no') {
                var coverProps = {};
                if (_step3Mode === 'preset-logo' && (fgFileUrls.presetLogo || _presetLogoFileName)) {
                    coverProps['Logofil'] = fgFileProp('presetLogo', _presetLogoFileName);
                    if (_presetLogoNote) coverProps['Notater'] = _presetLogoNote;
                }
                items.push(Object.keys(coverProps).length
                    ? { id: cover_box_id, quantity: _boxQty, properties: coverProps }
                    : { id: cover_box_id, quantity: _boxQty });
            }
            if (_logoEnabled) {
                var logoId = $('#logo-variant-id').val();
                if (logoId) items.push({ id: logoId, quantity: _boxQty, properties: { 'Logofil': fgFileProp('logo', _logoFileName), 'Notater': _logoNote || '' } });
            }
        }

        if (_step4Mode === 'corporate') {
            var cardCorpId = $('#card-corp-variant-id').val();
            if (cardCorpId) items.push({ id: cardCorpId, quantity: _boxQty, properties: { 'Designfil': fgFileProp('card4Corp', _card4CorpFileName), 'Notater': _card4CorpNote || '' } });
        } else {
            if (greeting_card_id !== undefined && greeting_card_id !== 'no') {
                var cardProps = { 'Gift Message': message || '' };
                if (_step4Mode === 'preset-logo' && (fgFileUrls.card4PresetLogo || _card4PresetLogoFileName)) cardProps['Logofil'] = fgFileProp('card4PresetLogo', _card4PresetLogoFileName);
                items.push({ id: greeting_card_id, quantity: _boxQty, properties: cardProps });
            }
            if (_step4Mode === 'ready' && _card4LogoEnabled) {
                var cardLogoId = $('#card-logo-variant-id').val();
                if (cardLogoId) items.push({ id: cardLogoId, quantity: _boxQty, properties: { 'Logofil': fgFileProp('card4Logo', _card4LogoFileName), 'Notater': _card4LogoNote || '' } });
            }
        }
    }

    // ── Step 3: fetch logo + corp cover variant IDs from Shopify ─────
    function fetchStep3Variants() {
        $.getJSON('/products.json?limit=250', function (data) {
            (data.products || []).forEach(function (p) {
                var tags = p.tags || '';
                if (tags.indexOf('custom logo addon') !== -1 && p.variants.length) {
                    var price = parseFloat(p.variants[0].price);
                    $('#logo-variant-id').val(p.variants[0].id).data('price', price);
                    if (price > 0) $('#logo-addon-price-label').text('(+' + price.toFixed(0) + ',-)');
                }
                if (tags.indexOf('corporate cover') !== -1 && p.variants.length) {
                    var price = parseFloat(p.variants[0].price);
                    $('#corp-cover-variant-id').val(p.variants[0].id).data('price', price);
                    if (price > 0) {
                        var $intro = $('#corp-panel-intro');
                        $intro.text($intro.text() + ' Pris: ' + price.toFixed(0) + ',-');
                    }
                }
                // Build preview cache: images[1..3] for per-box-size selection
                if (p.handle && p.images && p.images.length > 1) {
                    var arr = [];
                    for (var i = 1; i <= 3; i++) {
                        var img = p.images[i];
                        if (!img) break;
                        var rawSrc = (typeof img === 'object' && img.src) ? img.src : img;
                        arr.push(rawSrc.replace(/(\.[a-z]+)(\?|$)/i, '_2048x$1$2'));
                    }
                    if (arr.length) _previewCache[p.handle] = arr;
                }
            });
            fetchCoverVideos();
            price_calculate();
        });
    }

    function fetchCoverVideos() {
        $('.cover-box[data-handle]').each(function () {
            var handle = $(this).data('handle');
            if (!handle) return;
            var small  = $(this).data('video-small')  || '';
            var medium = $(this).data('video-medium') || '';
            var large  = $(this).data('video-large')  || '';
            if (small || medium || large) {
                _previewCache[handle] = [
                    { url: small  || medium || large, type: 'video' },
                    { url: medium || small  || large, type: 'video' },
                    { url: large  || medium || small, type: 'video' }
                ];
            }
        });
    }

    // ── Step 4: fetch card logo + corp card variant IDs from Shopify ──
    function fetchStep4Variants() {
        $.getJSON('/products.json?limit=250', function (data) {
            (data.products || []).forEach(function (p) {
                var tags = p.tags || '';
                if (tags.indexOf('custom card logo addon') !== -1 && p.variants.length) {
                    var price = parseFloat(p.variants[0].price);
                    $('#card-logo-variant-id').val(p.variants[0].id).data('price', price);
                    if (price > 0) $('#card-logo-addon-price-label').text('(+' + price.toFixed(0) + ',-)');
                }
                if (tags.indexOf('corporate card design') !== -1 && p.variants.length) {
                    var price = parseFloat(p.variants[0].price);
                    $('#card-corp-variant-id').val(p.variants[0].id).data('price', price);
                    if (price > 0) {
                        var $intro = $('#card-corp-panel-intro');
                        $intro.text($intro.text() + ' Pris: ' + price.toFixed(0) + ',-');
                    }
                }
            });
            price_calculate();
        });
    }

    // ── Init ──────────────────────────────────────────────────────────
    // Sort step1 box cards by price ascending
    var $step1c = $('.step1-c');
    $step1c.find('.step1-child').sort(function (a, b) {
        return parseFloat($(a).data('price')) - parseFloat($(b).data('price'));
    }).appendTo($step1c);

    // Disable logo-addon-sections on page load (no selection yet)
    $('#preset-logo-addon-section').addClass('logo-upload-disabled');
    $('#ready-logo-addon-section').addClass('logo-upload-disabled');
    $('#step4-panel-ready .logo-addon-section').addClass('logo-upload-disabled');

    var _stripEl = document.getElementById('cmb-ftr-macron-strip');
    if (_stripEl) _stripEl.addEventListener('scroll', updateFades, { passive: true });
    fetchStep3Variants();
    fetchStep4Variants();
    updateFooterBtn(1);
    $('#cmb-footer-bar').show();
    history.replaceState({ wizardBase: true }, '');
    price_calculate();
    setTimeout(function () {
        if (window.innerWidth <= 640) {
            var tabTop = $('#cmb-tabs').offset().top;
            $('html, body').animate({ scrollTop: Math.max(0, tabTop - 20) }, 500);
        } else {
            var step1Top = $('#step1').offset().top;
            $('html, body').animate({ scrollTop: Math.max(0, step1Top - 30) }, 500);
        }
    }, 300);

});
